var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.583,
    height: 19.236,
    viewBox: "0 0 27.583 19.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16024",
    "data-name": "Group 16024",
    transform: "translate(-266.337 -633.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_56",
    "data-name": "Union 56",
    d: "M2096.639-4633.257h-.018l-.019,0a6.13,6.13,0,0,1-4.135-2.149c-1.593-1.894-3.2-3.825-4.757-5.695l-.992-1.192a2.507,2.507,0,0,1-.413-2.894,2.513,2.513,0,0,1,2.293-1.423,2.475,2.475,0,0,1,.308.012,2.873,2.873,0,0,1,1.885,1.15c1.024,1.234,2.069,2.487,3.079,3.7l1.115,1.337.385.465c.281.341.573.692.863,1.033a1.349,1.349,0,0,0,.726.535c.21.022.48-.149.8-.511l5.09-5.71q2.063-2.315,4.128-4.632l.529-.6c.541-.613,1.1-1.246,1.68-1.849a2.415,2.415,0,0,1,2.036-.787,2.822,2.822,0,0,1,.656.154,2.508,2.508,0,0,1,1.7,2.163,2.729,2.729,0,0,1-.846,2.2c-1.121,1.253-2.258,2.53-3.359,3.764l-1.5,1.683-1.723,1.934c-1.554,1.743-3.161,3.546-4.744,5.316a5.794,5.794,0,0,1-4.427,2.007Q2096.811-4633.248,2096.639-4633.257Z",
    transform: "translate(-1819.681 5286.342)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon-tick.462293978af3814d998b2d40ab7e6fd1.svg";
export { ForwardRef as ReactComponent };